import { ITestConfigOptions } from "../views/TestView/Contracts";
import { UHFEnvironments, UHFLinkType, UHFvNextEnvironments, UHFvNowEnvironments } from "./Constants";

export const constructUHFUrl = (partnerId: string, locale: string, environment: UHFEnvironments, options: ITestConfigOptions, linkType: UHFLinkType, headerId?: string, footerId?: string) => {
    const getEnvironment = () => {
        switch(environment) {
            case UHFEnvironments.PROD:
                return UHFvNowEnvironments.PROD;
            case UHFEnvironments.PPE:
                return UHFvNowEnvironments.PPE;
            case UHFEnvironments.INT:
                return UHFvNowEnvironments.INT;
            case UHFEnvironments.DEV:
                return UHFvNowEnvironments.DEV;
            case UHFEnvironments.NEXT:
                return UHFvNextEnvironments.PROD;
        }
    }
    
    let url = `${getEnvironment()}/${locale}/shell/${linkType}/${partnerId}`;
    let queryString = constructUHFQuery(options, headerId, footerId);

    if(queryString) {
        return `${url}?${queryString}`;
    }
    return url;
}

export const constructUHFLoaderUrl = (partnerId: string, locale: string, environment: UHFEnvironments, options: ITestConfigOptions, headerId?: string, footerId?: string) => {
    let url = `/${locale}/Test/FullPage?PartnerId=${partnerId}&Environment=${environment}`;
    let queryString = constructUHFQuery(options, headerId, footerId);
    
    if(queryString) {
        return `${url}&${queryString}`;
    }
    return url;
}

const constructUHFQuery = (options: ITestConfigOptions, headerId?: string, footerId?: string) => {
    let queryParams: string[] = [];

    if(headerId) {
        queryParams.push(`HeaderId=${headerId}`);
    }

    if(footerId) {
        queryParams.push(`FooterId=${footerId}`);
    }

    if(options.cookieCompliance) {
        queryParams.push(`CookieComplianceEnabled=1`);
    }

    if(options.debug) {
        queryParams.push(`Debug=1`);
    }

    if(options.vNext) {
        queryParams.push(`vNext=1`);
    }

    if(options.preview) {
        queryParams.push(`Preview=1`);
    }

    if(queryParams.length > 0) {
        return queryParams.join("&");
    }
    return null;
}